import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

export interface ISyncAttachmentsBody {
  contactId: string
  locationId: string
  sourceId: string
  attachments: string[]
  attachmentType: DocumentsAttachmentType
  channel?: string
}

export enum DocumentsAttachmentType {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound'
}

// Configure request setup
const serviceName = 'DocumentService'
const host = servicesConfig.Documents
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const DocumentService = {
  upload: (params: { locationId: string, contactId: string, customFieldId: string, folderKey: string }, file: any) =>
    request().post(
      `/upload?locationId=${params.locationId}&contactId=${params.contactId}&customFieldId=${params.customFieldId}&folderKey=${params.folderKey}`,
      file
    ).then(responseBody),
    
  syncAttachments: (body: ISyncAttachmentsBody) =>
    request().post(`/syncAttachments`, body).then(responseBody)
}

export default DocumentService
